import { Theme, useTheme } from '@mui/material';
import React, { useContext } from 'react';
import EDTypography from '../../../../../../../BaseComponents/Typography/EDTypography';
import { useIsSmallBreakpoint } from '../../../../../../../Components/BreakpointContext/BreakpointContextUtils';
import { TEDEKBokforderMinBokforderStatusEnum } from '../../../../../../../globalQueryTypes';
import { safeGetAttributeInfo } from '../../../../../../../Model/avenyModelUtils';
import { ModelContext } from '../../../../../../../Model/ModelContext/ModelContext';
import { ValueType } from '../../../../../../../Utils/Formatters/FormatterTypes';
import { BusinessDataFormContext } from '../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import { useVisningstypContext } from '../../../../../_Common/Components/BusinessCollectionComponents/VisningsTypContext/VisningsTypContext';
import BusinessDetailContext from '../../../../../_Common/Components/BusinessDetailContext/BusinessDetailContext';

interface IProps {
  value: ValueType;
  displayValue: string;
}

interface IStatusColor {
  backgroundColor: string;
  fontColor: string;
}

const getStatusColor = (value: string, theme: Theme): IStatusColor => {
  switch (value) {
    case TEDEKBokforderMinBokforderStatusEnum.UTKAST:
      return {
        backgroundColor: theme.customProperties.Legend.pink.faded,
        fontColor: theme.customProperties.Legend.pink.full,
      };
    case TEDEKBokforderMinBokforderStatusEnum.ATTESTERAD__HOS_ANNAN_ATTESTANT:
    case TEDEKBokforderMinBokforderStatusEnum.ATTESTERAS__HOS_ATTESTANT:
      return {
        backgroundColor: theme.customProperties.Legend.indigo.faded,
        fontColor: theme.customProperties.Legend.indigo.full,
      };
    case TEDEKBokforderMinBokforderStatusEnum.VERIFIKATION_KORRIGERAD__ATTESTANT_:
    case TEDEKBokforderMinBokforderStatusEnum.VERIFIKATION_KORRIGERAD__BESTALLARE_:
      return {
        backgroundColor: theme.customProperties.Legend.orange.faded,
        fontColor: theme.customProperties.Legend.orange.full,
      };
    case TEDEKBokforderMinBokforderStatusEnum.EJ_GODKAND_AV_ATTESTANT:
    case TEDEKBokforderMinBokforderStatusEnum.ATT_ATTESTERA:
    case TEDEKBokforderMinBokforderStatusEnum.ATT_KONTROLLATTESTERA:
      return {
        backgroundColor: theme.customProperties.Legend.lightBlue.faded,
        fontColor: theme.customProperties.Legend.lightBlue.full,
      };
    case TEDEKBokforderMinBokforderStatusEnum.ATTESTERAD__ATTESTANT_:
    case TEDEKBokforderMinBokforderStatusEnum.ATTESTERAD__BESTALLARE_:
    case TEDEKBokforderMinBokforderStatusEnum.KONTROLLATTESTERAD__ATTESTANT_:
    case TEDEKBokforderMinBokforderStatusEnum.VERIFIKATION_SKAPAD__ATTESTANT_:
    case TEDEKBokforderMinBokforderStatusEnum.VERIFIKATION_SKAPAD__BESTALLARE_:
    case TEDEKBokforderMinBokforderStatusEnum.DEFINITIVBOKFORD__ATTESTANT_:
    case TEDEKBokforderMinBokforderStatusEnum.DEFINITIVBOKFORD__BESTALLARE_:
      return {
        backgroundColor: theme.customProperties.Legend.darkGreen.faded,
        fontColor: theme.customProperties.Legend.darkGreen.full,
      };
    default:
      return {
        backgroundColor: theme.customProperties.Legend.lightBlue.faded,
        fontColor: theme.customProperties.Legend.lightBlue.full,
      };
  }
};

const BokforderMinStatusComp: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const theme = useTheme();
  const visningsTypContext = useVisningstypContext();
  const isSmallScreen = useIsSmallBreakpoint();

  const formContext = useContext(BusinessDataFormContext);
  const businessDetailContext = useContext(BusinessDetailContext);
  const { avenyCollectionMap } = useContext(ModelContext);

  const attributeInfo = safeGetAttributeInfo(
    'EKBokforder',
    'STATUS',
    avenyCollectionMap
  );

  const enumSortValues = attributeInfo.isOk()
    ? attributeInfo.value.attribute.EnumValues
    : undefined;

  let enumDisplayValue = '';
  if (enumSortValues) {
    enumSortValues.forEach((value, key) => {
      if (key === businessDetailContext?.data?.STATUS) {
        enumDisplayValue = value;
      }
    });
  }

  const valueString: string = props?.value?.toLocaleString() ?? '';
  const displayValue: string =
    props.displayValue !== '' ? props.displayValue : enumDisplayValue;
  const statusColor = getStatusColor(valueString, theme);

  return (
    <EDTypography
      variant="inherit"
      sx={
        formContext ||
        isSmallScreen ||
        visningsTypContext.visningsTyp === 'kort' ||
        visningsTypContext.visningsTyp === 'lista'
          ? {}
          : {
              backgroundColor: statusColor.backgroundColor,
              minWidth: '217px',
              py: 0.75,
              px: 1.25,
              display: 'flex',
              alignItems: 'center',
              borderRadius: 2,
              justifyContent: 'center',
              color: 'text.primary',
              height: '34px',
              boxSizing: 'border-box',
              margin: '4px 0',
            }
      }
    >
      {displayValue}
    </EDTypography>
  );
};

export default BokforderMinStatusComp;
